import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11.18 20.274l-2.18 .726v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v3","key":"svg-0"}],["path",{"d":"M15 19l2 2l4 -4","key":"svg-1"}]]

const IconFilterCheck = createReactComponent('outline', 'filter-check', 'FilterCheck', __iconNode);

export default IconFilterCheck;